export default "__VITE_ASSET__BKhqugJT__"